





























































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import moment from 'moment';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { delay, difference, uniq, without } from "lodash";
import Snackbar from '@/components/shared/Snackbar.vue';
import IOutbound from '@/store/models/IOutbound';
@Component({
    components: {
        FilterMenu,
        Snackbar
    }
})
export default class OutboundDetailCustomerStockSelector extends Vue {
    menu2: boolean = false;
    searchOutboundDetailCustomerStock: string = "";
    dialog: boolean = false;
    dialogPallets: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Good Code', value: 'goodCode' },
        { text: 'Inb. Code', value: 'codeInbounds' },
        { text: 'Inb. Dossier Number Destination', value: 'codeDestination' },
        { text: 'Date In', value: 'dateIn' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Location', value: 'location', sortable: false },
        { text: 'Pallets amount', value: 'availablePalletsAmountFinal' },
        { text: 'Total cases', value: 'availableCasesFinal' },
        { text: 'Weight per pallet (Kg)', value: 'weight' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Language', value: 'language' },
        { text: 'Douana document', value: 'documentation' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    headersPallets: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet Id', value: 'idPallet' },
        { text: 'Total cases', value: 'availableCasesFinal' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Location', value: 'location' }
    ];
    editedIndex : number = -1;
    editedItem : IOutboundDetail = {
        id: "",
        idOutbound: "",
        idInbound: "",
        codeInbound: "",
        codeDestination: "",
        idGood: "",
        goodName: "",
        totalPallets: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        inDeliveryNote: 0,
        warehouseName: "",
        language: "",
        documentation: false,
        idWarehouse: "",
        availableCasesFinal: 0,
        casesLoss: 0,
        weight: 0,
        liters: 0,
        totalValue: 0,
        idPalletCustomer: "",
        idListPallet: "",
        palletName: "",
        goodCode: ""
    }
    defaultItem : IOutboundDetail = {
        id: "",
        idOutbound: "",
        idInbound: "",
        codeInbound: "",
        codeDestination: "",
        idGood: "",
        goodName: "",
        totalPallets: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        inDeliveryNote: 0,
        warehouseName: "",
        language: "",
        documentation: false,
        idWarehouse: "",
        availableCasesFinal: 0,
        casesLoss: 0,
        weight: 0,
        liters: 0,
        totalValue: 0,
        idPalletCustomer: "",
        idListPallet: "",
        palletName: "",
        goodCode: ""
    }

    goodNamesFilter : string[] = [];
    goodCodeFilter : string[] = [];
    inboundCodeFilter : string[] = [];
    inboundCodeDestinationFilter : string[] = [];
    maxTotalCases : number = 0;
    loadingVariable : boolean = false;

    @Prop({ type: Array, required: true })
    StockListCustomer !: IStock[];
    @Prop({ type: Array, required: true })
    StockListCustomerPalletsAmount !: IStock[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Boolean, default: false })
    ScannerActive!: boolean;
    @Prop()
    value !: IOutboundDetail[];

    selectedCustomerStockDetail : IOutboundDetail[] = [];
    selectedOutboundDetail : IOutboundDetail = {} as IOutboundDetail;
    bestBeforeDate: string = new Date().toISOString().substr(0, 10);
    
    async mounted() {
        // 👉 Si el escáner está activo, cambiar cabecera de Language → Merken nummer
        if (this.ScannerActive) {
            const idx = this.headers.findIndex((h: { text: string; value: string }) => h.value === 'language');
            if (idx !== -1) {
                this.headers[idx].text = 'Merken nummer';
                this.headers[idx].value = 'idPalletCustomer';
            }
        }
    }

    get formTitle() { return this.editedIndex === -1 ? 'Add customer stock' : 'Edit customer stock'; }

    ToDateFormat(date: any): string {
        if (!date) return "";
        return moment(date).format("DD-MM-YYYY");
    }

    @Watch('value')
    updateSelection(newValue : IOutboundDetail[] | null) {
        if (newValue !== null) {
            if (newValue!.length === 0) {
                this.selectedCustomerStockDetail = [];
            }
        }
    }

    @Watch('selectedCustomerStockDetail')
    onChangeselectedCustomerStockDetail() {
        if (this.selectedCustomerStockDetail.length > 0) {
            this.$emit('input', this.selectedCustomerStockDetail);
        } else {
            this.$emit('input', null);
        }
    }

    get goodNames() : string[] {
        return uniq(
            this.StockListCustomer
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    get goodCodes() : string[] {
        return uniq(
            this.StockListCustomer
            .filter(b => b.goodCode !== null && b.goodCode !== "")
            .map(b => b.goodCode)
        );
    }

    get inboundCodes() : string[] {
        return uniq(
            this.StockListCustomer
            .filter(b => b.codeInbounds !== null)
            .map(b => b.codeInbounds)
        );
    }

    get inboundCodeDestinations() : string[] {
        return uniq(
            this.StockListCustomer
            .filter(b => b.codeDestination !== null)
            .map(b => b.codeDestination)
        );
    }

    getLocations(location: string | null | undefined): string[] {
        if (!location) return [];

        return Array.from(
            new Set(
                location
                .split('|')
                .map(x => x.trim())
                .filter(x => x !== "")
            )
        );
    }

    getLocationPreview(location: string | null | undefined): string {
        const locations = this.getLocations(location);

        if (locations.length === 0) return "";
        if (locations.length === 1) return locations[0];
        if (locations.length === 2) return `${locations[0]}, ${locations[1]}`;

        return `${locations[0]}, ${locations[1]} +${locations.length - 2}`;
    }

    hasMultipleLocations(location: string | null | undefined): boolean {
        return this.getLocations(location).length > 1;
    }

    CalculateGoods() {
        if (this.editedItem.availableCasesFinal > 0 && this.editedItem.goodsPerCase > 0) {
            this.editedItem.totalGoods = this.editedItem.availableCasesFinal * this.editedItem.goodsPerCase;
        }
    }

    editOutboundCustomerStock (item: any, dbox = true) {
        this.maxTotalCases = item.availableCasesFinal;
        this.editedIndex = this.StockListCustomer.indexOf(item);
        if (this.editedItem.documentation === null) {
            this.editedItem.documentation = false;
        }
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    getPalletsCustomerStock(item: IOutboundDetail) {
        this.$emit('getStockPalletsAmount', item);
        this.selectedOutboundDetail = item;
        this.dialogPallets = true;
    }

    saveOutboundDetailCustomerStock() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.bestBeforeDate = new Date(this.bestBeforeDate);
            let index = this.StockListCustomer.findIndex(i => i.id === this.editedItem.id);
            this.editedItem.totalCases = this.editedItem.availableCasesFinal;
            this.editedItem.idWarehouse = this.StockListCustomer[index].idWarehouse;
            Object.assign(this.StockListCustomer[index], this.editedItem);
            this.close();
        } else {
            this.showMessageWarning("Please, some fields have not passed the validation to be able to save.");
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    get isLoading() {
        return this.StockListCustomer.length === 0;
    }

    get stockItemsFiltered() : IStock[] {
        this.loadingVariable = true;
        let filteredList: IStock[] = this.StockListCustomer.filter(s => s.availableCasesFinal > 0);
        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.inboundCodeDestinationFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeDestinationFilter.includes(b.codeDestination));
        }
        if (this.goodNamesFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodNamesFilter.includes(b.goodName));
        }
        if (this.goodCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodCodeFilter.includes(b.goodCode));
        }
        this.loadingVariable = false;
        return filteredList;
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
}
